import React from 'react';

import SwiperCore, { Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.scss';
import 'swiper/modules/pagination/pagination.scss';
import 'swiper/modules/autoplay/autoplay.scss';

import styled from 'styled-components';

SwiperCore.use([Pagination, Autoplay]);

function ValuesSlider() {
  return (
    <StyledValuesSlider>
      <Swiper {...settings}>
        <SwiperSlide>
          <StyledValue>
            <StyledValueTitle>SMART 현명함</StyledValueTitle>
            <StyledValueSubtitle>Smart</StyledValueSubtitle>
            <StyledValueDescription>
              성공적인 투자를 위해서는 단순한 "똑똑함"을 넘어서는 <br />
              "현명함"이 필요합니다. 기계가 가진 똑똑함은 사람을 능가하지만,
              <br />
              결코 기계는 스스로 현명해질 수는 없습니다. <br />
              우리는 사람만이 갖출 수 있는 현명함이 가진 힘을 믿습니다.
            </StyledValueDescription>
          </StyledValue>
        </SwiperSlide>
        <SwiperSlide>
          <StyledValue>
            <StyledValueTitle>INTERGRITY 진실됨</StyledValueTitle>
            <StyledValueSubtitle>Intergrity</StyledValueSubtitle>
            <StyledValueDescription>
              "지능과 열정만 있고 진실성이 없는 직원은 최악이다."
              <br />
              전설적인 투자자 ‘워런 버핏’이 남긴 말입니다.
              <br />
              우리는 진실된 마음을 가진 자만이 지능과 열정의 힘을 빌어
              <br />
              세상을 더 나은 곳으로 바꿀 수 있다고 믿습니다.
            </StyledValueDescription>
          </StyledValue>
        </SwiperSlide>
        <SwiperSlide>
          <StyledValue>
            <StyledValueTitle>PROFESSIONAL 전문성</StyledValueTitle>
            <StyledValueSubtitle>Professional</StyledValueSubtitle>
            <StyledValueDescription>
              겉으로 보이는 성공적인 성과에는 겉으로는 보이지 않는
              <br /> 치열하게 고민해야만 만들어낼 수 있는 디테일들이 숨어
              있습니다.
              <br /> 우리는 그 어떤 똑똑한 알고리즘도 결국 치열하게 고민하는
              사람의
              <br /> 머리와 손에 의해 완성된다는 것을 믿습니다.
            </StyledValueDescription>
          </StyledValue>
        </SwiperSlide>
      </Swiper>
    </StyledValuesSlider>
  );
}

export default ValuesSlider;

const StyledValuesSlider = styled.div`
  text-align: center;

  .swiper-slide .swiper-container {
    position: static;
  }

  .swiper-container {
    position: static;
    margin: 0 30px;
    background-color: rgba(40, 222, 44, 0.1);
  }

  .swiper-wrapper {
    margin-bottom: 32px;
  }

  .swiper-pagination {
    bottom: -35px;

    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background-color: ${({ theme: { colors } }) => colors.grey2};
      transition: all 0.3s;
    }

    .swiper-pagination-bullet-active {
      width: 35px;
      background-color: ${({ theme: { colors } }) => colors.green};
      border-radius: 10px;
      transition: all 1s;
    }
  }
`;

const StyledValue = styled.div`
  padding: 28px 30px 0;
`;

const StyledValueTitle = styled.div`
  margin-bottom: 70px;
  font-size: ${({ theme }) => theme.pixelToRem(14)};
  font-weight: 700;
`;

const StyledValueSubtitle = styled.div`
  margin-bottom: 10px;
  font-size: ${({ theme }) => theme.pixelToRem(24)};
  font-weight: 700;
`;

const StyledValueDescription = styled.p`
  font-size: ${({ theme }) => theme.pixelToRem(14)};
`;

const settings = {
  className: 'swiper-container',
  slidesPerView: 1,
  navigation: true,
  pagination: { clickable: true },
  scrollbar: { draggable: true },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  speed: 1000,
  loop: true,
};
